import { render, staticRenderFns } from "./CheckBasket.vue?vue&type=template&id=222828ee&scoped=true&"
import script from "./CheckBasket.vue?vue&type=script&lang=js&"
export * from "./CheckBasket.vue?vue&type=script&lang=js&"
import style0 from "./CheckBasket.vue?vue&type=style&index=0&id=222828ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222828ee",
  null
  
)

export default component.exports